import { useEffect } from "react";
import { circleTick, rightArrow } from "@simplybusiness/icons";
import { Button, Flex, Icon, Text } from "@simplybusiness/mobius";
import { getCoversByTrade } from "../../../../utils";

interface CoverDisplayProps {
  trade: string;
  onCTAClick: () => void;
  fireEvent: (action: string) => void;
}

export const CoverDisplay = ({
  trade,
  onCTAClick,
  fireEvent,
}: CoverDisplayProps) => {
  const tradeCovers = getCoversByTrade(trade);

  useEffect(() => {
    fireEvent("cd_cover_list_shown");
  }, [fireEvent]);

  return (
    <Flex flexDirection="column" alignItems="center" justifyContent="center">
      <Text
        elementType="h4"
        className="mobius-interventions__coverage-diagnosis-header"
      >
        Covers tailored to your business*
      </Text>
      <Text
        variant="small"
        className="mobius-interventions__coverage-diagnosis-text"
      >
        These covers are the most popular for
      </Text>
      <Text
        variant="small"
        className="mobius-interventions__coverage-diagnosis-trade-name"
      >
        {trade}
      </Text>
      <Flex flexDirection="column" alignItems="baseline" gap={4}>
        {["Public liability", ...tradeCovers!].map((cover: string) => (
          <Flex key={cover} justifyContent="center" alignItems="center" gap={8}>
            <Icon icon={circleTick} size="sm" color="green" />
            <Text variant="small" elementType="span">
              {cover}
            </Text>
          </Flex>
        ))}
      </Flex>
      <Button
        className="mobius-interventions__coverage-diagnosis-cover-display-cta"
        size="sm"
        onPress={onCTAClick}
      >
        Close and continue&nbsp;&nbsp;
        <Icon size="sm" icon={rightArrow}></Icon>
      </Button>
    </Flex>
  );
};
